module.exports = __webpack_public_path__ + "static/media/folder_black.062ed173.svg";